
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HttpClient,HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
// require('../assets/Scripts/SimpleCalendar/javascripts/simple-calendar-es6.js')
// require('../assets/Scripts/jedate-6.5.0/src/jedate.js')
//#region  
// require ('bootstrap/dist/css/bootstrap.min.css')
// require ('font-awesome/css/font-awesome.min.css')
// require ('dragula/dist/dragula.css')
// require ('cropperjs/dist/cropper.min.css')
// require('../assets/fonticon/iconfont.css')
// require('../assets/Scripts/jedate-6.5.0/skin/jedate.css')
// require('../assets/Scripts/SimpleCalendar/stylesheets/simple-calendar.css')
// require('../assets/Theme/default/Main.All.css')
//#endregion
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy, RouterModule, Routes } from '@angular/router';
import 'bootstrap/dist/js/bootstrap.min.js';
// import 'jquery/dist/jquery.min.js'
import 'ckeditor/ckeditor.js';
import 'cropperjs/dist/cropper.min.js';
import 'webuploader/dist/webuploader.min.js';
import '../assets/Scripts/common/colResizable-1.6.js';
import '../assets/Scripts/common/push-menu.js';
// import '../assets/Scripts/openseadragon/js/d3/d3.v5.min.js';
// import '../assets/Scripts/openseadragon/js/openseadragon/OpenSeadragonHTMLelements.js';
// import '../assets/Scripts/openseadragon/js/openseadragon/openseadragonselection.js';
import { AppComponent } from './app.component';
import { HomeModule } from './home/home.module';
import { SwException403Component } from './home/sw-exception/403.component';
import { SwException404Component } from './home/sw-exception/404.component';
import { SwHomeComponent } from './home/sw-home/sw-home.component';
import { SwCheckAttachmentComponent } from './librarys/components/basic-components/sw-check-attachment/sw-check-attachment.component';
import { SwPhotoAlbumComponent } from './librarys/components/basic-components/sw-photo-album/sw-photo-album.component';
import { SwPhotoAlbumService } from './librarys/components/basic-components/sw-photo-album/sw-photo-album.service';
import { LazyDashboardTitleModules } from './librarys/serves/lazy-dashboard-title-modules.service';
import { ConfigurationService } from './librarys/serves/public/configuration.service';
import { SystemIdService } from './librarys/serves/public/system-id.service';
import { SwHttpClientService } from './librarys/serves/sw-http-client.service';
import { SwMassageBoxService } from './librarys/serves/sw-massage-box.service';
import { SwRouteguardService } from './librarys/serves/sw-routeguard.service';
import { SwSelectivePreloadingStrategy } from './librarys/serves/sw-selective-preloading-strategy';
import { SwSimpleReuseStrategy } from './librarys/serves/sw-simplereusestrategy';
import { SwWebSocketService } from './librarys/serves/sw-web-socket.service';
import { LoginComponent } from './login/login.component';
import { SwUnfocusGuardService } from './librarys/serves/sw-unfocus-guard.service';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import { ConsoleComponent } from './console/console.component';
import { BasicComponentsModule } from './librarys/components/basic-components/basic-components.module';
import { SwCompatibilityComponent } from './home/sw-exception/compatibility.component';
import { UserAutoLoginComponent } from './user-auto-login/user-auto-login.component';

// 这里配置
export function createTranslateHttpLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
///loadChildren是代表懒加载

const routes: Routes = [

  {
    path: '',
    component: SwHomeComponent,
    children: [
      // { path: 'oa',   loadChildren: './areas/oa/oa.module#OaModule',    data: { preload: true } },
      { path: 'bdp',  loadChildren: './areas/bdp/bdp.module#BdpModule' }, //preload 默认加载
      { path: 'kms',  loadChildren: './areas/kms/kms.module#KmsModule' },
      { path: 'se', loadChildren: './areas/se/se.module#SeModule'},
      { path: 'cms', loadChildren: './areas/cms/cms.module#CmsModule'},
      // { path: 'demo',  loadChildren: './areas/demo/demo.module#DemoModule' }, 
      { path: 'sw/console', component: ConsoleComponent ,canActivate: [SwRouteguardService],canDeactivate: [SwUnfocusGuardService],data:{routereuse:true}},
      { path: '404', component: SwException404Component },
      { path: '403', component: SwException403Component },
    ],
    
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'compatibility',
    component: SwCompatibilityComponent,
  },
  {
    path: 'userAutoLogin',
    component: UserAutoLoginComponent,
  },
  { path: '403', redirectTo: '403'},
  { path: 'sw', redirectTo: 'sw/console'},
  { path: '**', redirectTo: '404' },
];
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ConsoleComponent,
    SwPhotoAlbumComponent,
    UserAutoLoginComponent
  ],
  imports: [
    HttpClientModule,
    HomeModule,
    BasicComponentsModule,
    BrowserModule,
    HttpModule,
    RouterModule.forRoot(routes, { preloadingStrategy: SwSelectivePreloadingStrategy }),
    ReactiveFormsModule,
    FormsModule,
        // 在这里配置
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
          useFactory: (createTranslateHttpLoader),
          deps: [HttpClient]
      }
    })
  ],
  exports: [RouterModule],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: RouteReuseStrategy, useClass: SwSimpleReuseStrategy },
    SwMassageBoxService, SwPhotoAlbumService,LazyDashboardTitleModules,
    SwHttpClientService,SwWebSocketService,ConfigurationService,SystemIdService,
    SwSelectivePreloadingStrategy, SwRouteguardService,SwUnfocusGuardService],
  bootstrap: [AppComponent],
  entryComponents: [SwPhotoAlbumComponent,SwCheckAttachmentComponent,], 
})
export class AppModule {
}

